/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Info_CollapseInputs */

const vi_vehicle_info_collapse = /** @type {(inputs: Vehicle_Info_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu gọn`)
};

/**

* @param {Vehicle_Info_CollapseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_info_collapse = /** @type {((inputs?: Vehicle_Info_CollapseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Info_CollapseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_info_collapse(inputs)
});